import http from './http.js';


//保巡园任务的物候期
export function saveFarmPatrolTaskEnophase(work_task_id,params){
    return http.post(`/user/task/save_farm_patrol_task_enophase/`+work_task_id,params)
}

//保存巡园任务的植株观察情况
export function saveFarmPatrolTaskZhiZhu(work_task_id,params){
    return http.post(`/user/task/save_farm_patrol_task_zhizhu/`+work_task_id,params)
}
//保存巡园任务的植株观察情况
export function saveFarmPatrolTaskSoil(work_task_id,params){
    return http.post(`/user/task/save_farm_patrol_task_soil/`+work_task_id,params)
}
//保存巡园任务的病虫害情况
export function saveFarmPatrolTaskPest(work_task_id,params){
    return http.post(`/user/task/save_farm_patrol_task_pest/`+work_task_id,params)
}

//获取所有的病虫害
export function getPestList(){
    return http.get(`/data/pest/get_data_pest/0`)
}


//财务
//获取费用支出和收入选项
export function getFeeTypeList(val){
    return http.get(`/region/get_fee_type_list/`+val)
}
//保存财务类任务
export function SaveFarmFinanceTaskFee(work_task_id,params){
    return http.post(`/user/task/save_farm_finance_task_fee/`+work_task_id,params)
}
//保存营养管理类d
export function saveFarmWorkAlibleTaskOption(work_task_id,params){
    return http.post(`/user/task/save_farm_alible_task_option/`+work_task_id,params)
}
//删除营养管理类的肥料
export function deleteFarmWorkAlibleTaskOption(id){
    return http.delete(`/user/task/delete_farm_alible_task_option/`+id)
}
//采集类
export function saveFarmWorkCollectTaskTarget(work_task_id,params){
    return http.post(`/user/task/save_farm_collect_task_target/`+work_task_id,params)
}

export function saveFarmWorkCollectTaskPest(work_task_id,params){
    return http.post(`/user/task/save_farm_collect_task_pest/`+work_task_id,params)
}

//通用
export function SaveFarmLastTaskStatus(work_task_id,params){
    return http.post(`/user/task/save_farm_last_task_status/`+work_task_id,params)
}
export function saveFarmWorkTaskMaterial(work_task_id,params){
    return http.post(`/user/task/save_farm_task_material/`+work_task_id,params)
}
//提交每个步骤的值
export function saveFarmWorkTaskStep(work_task_id,params){
    return http.post(`/user/task/save_farm_work_task_step/`+work_task_id,params)
}
//提交状态
export function saveFarmTaskStatus(work_task_id,params){
    return http.post(`/user/task/save_farm_task_status/`+work_task_id,params)
}
export function getTaskWeatherList(work_task_id){
    return http.get(`/user/task/get_task_weather_list/`+work_task_id)
}

